export enum SiteRFPSummariesSortByParam {
  SiteName = 'siteName',
  CustomerRFPName = 'customerRFPName',
  Phase = 'phase',
  SystemSize = 'systemSize',
  ArrayLocation = 'arrayLocation',
  ConstructionStartDate = 'constructionStartDate',
}
